export class FetchGradingSchemeByModuleId {
    static readonly type = '[GradingScheme] FetchGradingSchemeByModuleId';

    constructor(
        public payload: {
            moduleId: string;
        }
    ) {}
}
